import { titanApi } from "./titanApi";

const downloadApi = titanApi.injectEndpoints({
  endpoints: (builder) => ({
    getGeoBimDownloadUrl: builder.query({
      query: () => "/api/download/geoBim/request",
      invalidatesTags: ["statistics"],
    }),
  }),
  overrideExisting: false,
});

export const { useLazyGetGeoBimDownloadUrlQuery } = downloadApi;
